var testStudioSorting = {

    sortTestStudios(testStudios, searchFeatures = null) {

        testStudios.sort((first, second) => {

            let featureOrder = null;

            if (searchFeatures && searchFeatures.length > 0) {
                featureOrder = this.getFeatureOrder(first.features, second.features, searchFeatures);
            }

            if (featureOrder === null || featureOrder === 0) {

                let locOrder = this.getCityOrder(first.locationData.cityData, second.locationData.cityData);

                if (locOrder === 0) {
                    if (first.displayName > second.displayName) {
                        return 1;
                    } else if (first.displayName < second.displayName) {
                        return -1;
                    } else {
                        return 0;
                    }
                } else {
                    return locOrder;
                }

            } else {
                return featureOrder;
            }

        });

    },

    getFeatureOrder(first, second, searchFeatures) {

        let availableCountFirst = first.filter(x => searchFeatures.includes(x.id) && [2, 3].includes(x.availability)).length;
        let availableCountSecond = second.filter(x => searchFeatures.includes(x.id) && [2, 3].includes(x.availability)).length;

        if (availableCountFirst > availableCountSecond) {
            return -1;
        } else if (availableCountFirst < availableCountSecond) {
            return 1;
        } else {
            return 0;
        }

    },

    getCityOrder(first, second) {

        if (first.countryData.continentData.displayName != second.countryData.continentData.displayName) {

            if (first.countryData.continentData.displayName > second.countryData.continentData.displayName) {
                return 1;
            } else {
                return -1;
            }

        } else {

            if (first.countryData.displayName != second.countryData.displayName) {

                if (first.countryData.displayName > second.countryData.displayName) {
                    return 1;
                } else {
                    return -1;
                }

            } else {

                if (first.displayName.split(',').length > 1 && second.displayName.split(',').length > 1 && first.displayName.split(',')[1].trim() != second.displayName.split(',')[1].trim()) {

                    let firstFedState = first.displayName.split(',')[1].trim();
                    let secondFedState = second.displayName.split(',')[1].trim();

                    if (firstFedState > secondFedState) {
                        return 1;
                    } else {
                        return -1;
                    }

                } else {

                    if (first.displayName > second.displayName) {
                        return 1;
                    } else if (first.displayName < second.displayName) {
                        return -1;
                    } else {
                        return 0;
                    }

                }

            }

        }
    }
}

module.exports = testStudioSorting;